import { FC } from 'react';

import { Image } from 'src/general/components/Image/Image';

type HighlightedFeatureCarouselTileProps = {
  title: string;
  imgUrl: string;
};

export const HighlightedFeatureCarouselTile: FC<HighlightedFeatureCarouselTileProps> = ({ title, imgUrl }) => {
  return (
    <div className="relative flex h-36.5 w-65 flex-col justify-end overflow-hidden rounded-xs p-1">
      <Image
        className="absolute top-0 left-0 block h-full w-full object-cover"
        src={imgUrl}
        width={260}
        height={146}
        alt={title}
        data-testid="carousel-specs-features-image"
      />
      <div className="c-fs-caption w-fit rounded-2xs bg-tex-inv-tie3 px-2 py-1 font-extrabold backdrop-blur-sm">
        {title}
      </div>
    </div>
  );
};
